import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from 'react-router-dom'
import { FaBars, FaTimes } from "react-icons/fa";

import Menu from "../../components/Menu/Menu"

import Home from "../../views/Home/Home";
import Map from "../../views/Map/Map";
import Explore from "../../views/Explore/Explore";
import { getMenu } from "../../assets/js/api";
import Report from "../../views/Report/Report";
import Captivity from "../../views/Captivity/Captivity";
import Credits from "../../views/Credits/Credits";
import { getCurrentLanguage, getLanguages, linkTo, translate } from "../../assets/js/functions";

export default function Section({openMenu}){

    const [dataMenu, setDataMenu] = useState([[translate("Inicio"), "/"+getCurrentLanguage()]]);
    const [menu = false, setMenu] = useState(false);
    const location = useLocation();

    useEffect(() => {
        getMenu().then(
            res => {
                res.data.result.map(
                    ent => {
                        if (ent.menu === "yes"){
                            setDataMenu(dataMenu => [...dataMenu, [translate(ent.term), linkTo(ent.web_path)]])
                        }
                        return null
                    }
                )
            }
        )
    }, [])

    function _stateMenu(state = !menu){
        setMenu(state);
        openMenu && openMenu(state);
    }

    return (
        <>
        <div className="app-content">
            <Routes>
                <Route path={getCurrentLanguage()+'/'} element={<Home/>} />
                <Route exact path={getCurrentLanguage()+'/captivity/:id'} element={<Captivity/>} />
                <Route path={getCurrentLanguage()+'/captivity'} element={<Captivity/>} />
                <Route path={getCurrentLanguage()+'/explore/:id'} element={<Explore/>} />
                <Route path={getCurrentLanguage()+'/map'} element={<Map/>} />
                <Route exact path={getCurrentLanguage()+'/report'} element={<Report data={dataMenu}/>} />
                <Route exact path={getCurrentLanguage()+'/credits'} element={<Credits/>} />
                <Route path={'*'} element={<Home/>} />
            </Routes>
        </div>
        { //(location.pathname !== "/" && location.pathname !== '/'+getCurrentLanguage() && location.pathname !== '/'+getCurrentLanguage()+'/') && 
        <span id="menu-btn" onClick={() => _stateMenu()}>{menu ? <FaTimes/> : <FaBars/>}</span>
        }
        { !!dataMenu.length &&
            <Menu   onMenuClick={() => _stateMenu()}
                    languages={getLanguages()}
                    items={dataMenu}
            />
        }
        </>
    );
}
